import React from 'react';
import styled from 'styled-components';

interface IProps {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
  background?: 'blue';
  heightPortrait?: string;
  heightLandscape?: string;
  widthPortrait?: string;
  widthLandscape?: string;
  allowHeightMax?: boolean;
}
type TProps = IProps;

export default function Modal({
  children,
  open,
  onClose,
  background,
  heightPortrait,
  heightLandscape,
  widthPortrait,
  widthLandscape,
  allowHeightMax,
}: TProps) {
  function handleClose(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    event.stopPropagation();
    onClose();
  }

  return (
    <Container
      background={background}
      className={open ? 'open' : ''}
      onClick={(e) => {
        handleClose(e);
      }}
    >
      <BgBluredImage />
      <SDivContent
        $heightPortrait={heightPortrait}
        $heightLandscape={heightLandscape}
        $widthLandscape={widthLandscape}
        $widthPortrait={widthPortrait}
        $allowHeightMax={allowHeightMax}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </SDivContent>
    </Container>
  );
}

const Container = styled.div<{
  background?: 'blue' | 'black' | 'transparent';
  padding?: string;
}>`
  align-items: center;
  background: linear-gradient(
    180deg,
    rgba(0, 202, 191, 0.6) 0%,
    rgba(0, 173, 212, 0.6) 100%
  );
  backdrop-filter: blur(18px);
  cursor: pointer;
  display: flex;
  justify-content: center;
  left: 0;
  top: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.5s linear;
  z-index: 5;

  &.open {
    opacity: 1;
    pointer-events: auto;
  }
`;

const BgBluredImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
`;

const SDivContent = styled.div<{
  $heightPortrait?: string;
  $heightLandscape?: string;
  $widthLandscape?: string;
  $widthPortrait?: string;
  $allowHeightMax?: boolean;
}>`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  height: ${({ $heightLandscape }) =>
    $heightLandscape ? $heightLandscape : 'auto'};

  width: ${({ $widthLandscape }) =>
    $widthLandscape ? $widthLandscape : 'auto'};
  @media screen and (max-height: 415px) {
    height: ${({ $allowHeightMax }) => $allowHeightMax && '95%'};
    width: 100%;
  }

  @media screen and (orientation: portrait) {
    height: ${({ $heightPortrait }) =>
      $heightPortrait ? $heightPortrait : 'auto'};
    width: ${({ $widthPortrait }) =>
      $widthPortrait ? $widthPortrait : 'auto'};
  }
`;
